<div class="contentDiv">
  <div class="broker-details">
    <div id="image-container">
      <div id="logo"><img [src]="imgUrl" alt="{{ brokerId }}" /></div>
    </div>
    <div class="details">
      <div id="analyst_fn_ln">{{ brokerName }}</div>
      <div *ngFor="let disdata of disclosureData" class="disclosure_link">
        <a
          *ngIf="disdata.external_link == true"
          (click)="showDisclosure(disdata.url, disdata.external_link)"
          >{{ disdata.name }}
          <va-icon size="small" class="disclosure-icon" name="external-link">
          </va-icon>
          <!--image?-->
        </a>

        <span *ngIf="disdata.external_link == false">
          <!--wimplement showDisclosure() -->
          <a
            style="cursor: pointer"
            (click)="showDisclosure(disdata.url, disdata.external_link)"
            [textContent]="disdata.name"
          ></a>
        </span>
      </div>
    </div>
  </div>
  <div class="broker-data">
    <div class="filter-container">
      <app-global-reporting-filters
        showModelOnly="false"
        [isSearchFilter]="showSearch"
        [exportColumns]="exportColumns"
        [exportKey]="exportKey"
        (isFilterValueChange)="toggleFilter($event)"
        (onGlobalFilterChange)="onSearch($event)"
        (onReloadGrid)="onReloadGrid()"
      ></app-global-reporting-filters>
    </div>
    <div class="grid-container">
      <app-reporting-grid-wrapper
        [page]="'broker'"
        [columns]="columns"
        [gridUrl]="gridUrl"
        [showGridFilters]="showGridFilters"
        [sortKey]="sortKey"
        [(globalSearchVal)]="globalSearchVal"
        *ngIf="isDataSet"
      ></app-reporting-grid-wrapper>
    </div>
  </div>
  <nz-modal
    [(nzVisible)]="isViewModalVisible"
    [nzFooter]="null"
    nzWidth="calc(100vw - 100px)"
    (nzOnCancel)="handleCancel()"
    nzTitle="&nbsp;"
  >
    <iframe
      [src]="disclosureUrl"
      frameborder="0"
      allowfullscreen
      width="100%"
      height="500px"
    ></iframe>
  </nz-modal>
</div>
